import { useSelector } from "react-redux";
import { selectPermissions } from "../redux/selectors/permissions";
import { IPermissions } from "../types/user/permissions/ipermissions/ipermissions.interface";
import { createUserPermissions } from "../types/user/permissions/ipermissions/ipermissions.functions";

export function usePermissions(): IPermissions {
  const defaultPermissions = createUserPermissions();
  const userPermissions = useSelector(selectPermissions);

  return { ...defaultPermissions, ...userPermissions };
}

export default usePermissions;
